import { ReactNode } from "react";
import { TopToolbar } from "react-admin";
import { BackToSkidButton } from "./BackToSkidButton";

export const SkidActions = ({extra}: { extra?: ReactNode[]}) =>(
    <TopToolbar sx={{ justifyContent: 'flex-start'}}>
        <BackToSkidButton />
        {extra}
    </TopToolbar>
)